import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { WMSContext } from './WMSContext';
import { UserAgentUtils } from "utils/useragent";

// some state can be replaced by SidebarContext
const WMSContextProvider = ({ children, member, authorizations, organization, history }) => {
    const [currentInventory, setCurrentInventory] = useState(null);
    const [currentMember, setCurrentMember] = useState(null);
    const [currentMemberAuthorizations, setCurrentMemberAuthorizations] = useState(null);
    const [currentOrganization, setCurrentOrganization] = useState(null);
    const [currentTask, setCurrentTask] = useState(null);
    const [preferredPrinter, setPreferredPrinter] = useState({});
    const [preferredPackingStation, setPreferredPackingStation] = useState({});
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        let preferredPrinterString = localStorage[organization?.id + '_preferredPrinters'];
        if (preferredPrinterString) {
            setPreferredPrinter({
                labelPrinterId: JSON.parse(preferredPrinterString).labelPrinterId,
                organizationId: organization?.id
            });
        }
        setCurrentMember(member);
        setCurrentMemberAuthorizations(authorizations);
        setCurrentInventory(member?.inventories?.[0]);
        setCurrentOrganization(organization);
        setIsMobile(UserAgentUtils.isMobileOrTablet());
    }, [member, authorizations, organization]);

    const groupWmsItemsBySku = (wmsItems) => {
        let groupedItems = [];
        wmsItems.forEach((item) => {
            const key = item.lineItem.variationSku;
            if (!groupedItems.some(i => i.lineItem.variationSku === key)) {
                item.count = 1;
                groupedItems.push(item);
            } else {
                groupedItems[groupedItems.findIndex(i => i.lineItem.variationSku === key)].count += 1;
            }
        });
        return groupedItems;
    };

    // Simple redirect function so that the chosen link is selected in the sidebar
    const redirect = (path) => history.push(path);

    return (
        <WMSContext.Provider value={{
            currentMemberAuthorizations,
            currentMember,
            currentInventory,
            currentOrganization,
            currentTask,
            preferredPrinter,
            preferredPackingStation,
            isMobile,
            setPreferredPackingStation,
            setCurrentTask,
            groupWmsItemsBySku,
            redirect
        }}>
            {children}
        </WMSContext.Provider>
    );
};

const mapStateToProps = state => ({
    authorizations: state.authentication.authorizations,
    member: state.authentication.member,
    organization: state.currentOrganization.retrieved
});

export default connect(mapStateToProps)(WMSContextProvider);
